module.exports = __webpack_public_path__ + "static/media/manTr.e8165efb.png";